import React, { useState } from 'react';
import { HiPhoneArrowUpRight } from "react-icons/hi2";
import { MdPlayLesson, MdStickyNote2  } from "react-icons/md";
import Loading from '../../../components/Loading';
import { CiLink } from "react-icons/ci";
import { FaCalendarCheck } from "react-icons/fa";

import {Link} from 'react-router-dom';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure,
  ModalCloseButton,
  ModalHeader,
  useToast,
} from '@chakra-ui/react'
import { GET } from '../../../utils/requests';
import { getuseruri } from '../../../uri';
import ProductSeeCard from './prodSeeCard';


const HomeIndex = () => {
  const [load, setLoad] = useState(false);
  const [phone_or_trackcode, setPhoneOrTrackcode] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [data, setData] = useState([]);
  const toast = useToast();

  function haha(){
    // Load({load: load})
  }

  const SubCheck = async () => {
    if(phone_or_trackcode === ""){
      return 
    }
    setLoad(true);
    const res = await GET(getuseruri+'/check-track'+`?data=${phone_or_trackcode}`);
    if(res.data.length !== 0){
      onOpen();
    }else{
      toast({title: 'Хайлтанд тохирох бараа байхгүй байна',status: 'warning',duration: 3000,isClosable: true, position: "top"})
    }
    setData(res.data);
    setLoad(false);
  }

  return (
    <div className='font-Roboto text-white'>
      {
        load &&
        <Loading/>
      }
      <div className='mt-6'>
          <img src='../BEST.png' className=' w-full xs:h-40 md:h-80 rounded-2xl ring-1 ring-white'/>
      </div>
      <h1 className=' uppercase font-bold mt-6 text-2xl'>Best каргонд тавтай морилно уу</h1>
      <div>
          <h1 className='mt-4'>Бараа шалгах</h1>
          <input  onChange={(e) => setPhoneOrTrackcode(e.target.value)} className='w-full xs:p-2 md:p-4 rounded-md mt-2 bg-gray-200 text-black outline-none focus:ring-3 ring-1 placeholder:text-sm ring-green-600' placeholder='Утасны дугаар эсвэл бар кодоор хайх'/>
          <button onClick={SubCheck} className='bg-[#c2a72f]  w-full p-2 rounded-md mt-2 font-bold text-white'>Шалгах</button>
      </div>

      <div className='grid grid-cols-3 mt-4 gap-2 w-full xs:text-[9px] md:text-sm'>
        <Link to="/contact" className='bg-white text-black p-4 rounded-md w-full shadow-sm shadow-white cursor-pointer hover:bg-shadow-xl flex justify-between flex-col'>
          <div className='flex justify-center'>
            <HiPhoneArrowUpRight size={44} color='orange'/>
          </div>
          <h1 className=' font-bold text-center mt-2'>Холбоо барих</h1>
        </Link>
        <Link to="/price" className='bg-white text-black p-4 rounded-md w-full shadow-sm shadow-white cursor-pointer hover:bg-shadow-xl flex justify-between flex-col'>
          <div className='flex justify-center'>
            <FaCalendarCheck   size={44} color='orange'/>
          </div>
          <h1 className=' font-bold text-center'> Үнийн мэдээлэл</h1>
        </Link>
        <Link to="/lesson" className='bg-white text-black p-4 rounded-md w-full shadow-sm shadow-white cursor-pointer hover:bg-shadow-xl flex justify-between flex-col'>
          <div className='flex justify-center'>
            <MdPlayLesson size={44} color='orange'/>
          </div>
          <h1 className=' font-bold text-center'>Заавар сургалт</h1>
        </Link>
        <Link to="/service" className='bg-white p-4 text-black rounded-md w-full shadow-sm shadow-white cursor-pointer hover:bg-shadow-xl flex justify-between flex-col'>
          <div className='flex justify-center'>
            <MdStickyNote2 size={44} color='orange'/>
          </div>
          <h1 className=' font-bold text-center'>Үйлчилгээний нөхцөл</h1>
        </Link>
      </div>

      <div className='flex justify-start mt-4 items-center gap-2  w-60 text-center'>
        <Link to="http://express.mengguyu.cn/#/" className='flex justify-center items-center bg-gray-200 text-black p-2 rounded-md shadow-md cursor-pointer'>
          <h1>Ачигдсан бараа шалгах</h1>
          <CiLink />
        </Link>
      </div>

      <Modal isOpen={isOpen} onClose={onClose} placement='bottom' scrollBehavior="inside" size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
              <div className='mt-8 mb-10'>
                <h1 className='mb-2'>Хайлтанд илэрсэн бараа</h1>
                {
                  data.map((it, index) => {
                    return(
                      <ProductSeeCard data={it} key={index}/>
                    )
                  })
                }
              </div>
          </ModalBody>
        </ModalContent>
      </Modal>

    </div>
  )
}

export default HomeIndex